import axios from "axios";
import api from "@/data/services/api";
import TokenService from "@/data/services/token.service";

export class AccountService {

  getQuizProgress() {
    return api.get('/quiz/progress')
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.data.data
        }
        console.log(response)
      })
      .catch(error => {
        console.log({ error })
      })
  }

  getLessons() {
    return axios.get('https://classroom.concinnitylimited.com/wp-json/api/v1/classroom/lessons')
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.data.data
        }
        console.log(response)
      })
      .catch(error => console.log({ error }))
  }

  getUserList() {
    return api.get('/user/list')
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.data.data
        }
        console.log(response)
      })
      .catch(error => {
        console.log({ error })
      })
  }
  getUserProfile() {
    return axios({
      baseURL: "https://api.classroom.concinnitylimited.com/api/user/profile/me",
      headers: {
        "Authorization": `Bearer ${TokenService.getLocalAccessToken()}`,
        "Content-Type": "application/json",
      },
    }).then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.data.data
        }
        console.log(response)
      })
      .catch(error => {
        console.log({ error })
      })
  }
}
